import React, { useEffect } from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import { Close, Warning, FlashOn, Bolt } from '@mui/icons-material';

const SEVERITY_CONFIG = {
  EXTREME: { color: '#b71c1c', bg: 'rgba(183,28,28,0.15)', icon: <Bolt />, label: 'EXTREME' },
  HIGH:    { color: '#e65100', bg: 'rgba(230,81,0,0.15)',  icon: <Warning />, label: 'HIGH' },
  MODERATE:{ color: '#f57f17', bg: 'rgba(245,127,23,0.12)',icon: <FlashOn />, label: 'MODERATE' },
  LOW:     { color: '#2e7d32', bg: 'rgba(46,125,50,0.12)', icon: <FlashOn />, label: 'LOW' },
};

export default function LiveAlertBanner({ alert, onDismiss }) {
  const cfg = SEVERITY_CONFIG[alert.severity] || SEVERITY_CONFIG.MODERATE;

  useEffect(() => {
    const t = setTimeout(onDismiss, 8000);
    return () => clearTimeout(t);
  }, [onDismiss]);

  return (
    <Paper elevation={8} sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5,
      p: 1.5, width: 320, bgcolor: cfg.bg,
      border: `1px solid ${cfg.color}`,
      borderRadius: 2,
      animation: 'slideInRight 0.3s ease',
      '@keyframes slideInRight': {
        from: { transform: 'translateX(100%)', opacity: 0 },
        to:   { transform: 'translateX(0)',    opacity: 1 },
      },
    }}>
      <Box sx={{ color: cfg.color, mt: 0.2 }}>{cfg.icon}</Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" sx={{ color: cfg.color, fontWeight: 800, letterSpacing: 1 }}>
          🌞 {cfg.label} SPACE WEATHER ALERT
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.primary', mt: 0.3, fontSize: 12 }}>
          {alert.eventType?.replace('_', ' ')} detected
        </Typography>
        {alert.description && (
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.3 }}>
            {alert.description.slice(0, 80)}…
          </Typography>
        )}
      </Box>
      <IconButton size="small" onClick={onDismiss} sx={{ color: 'text.secondary', p: 0.3 }}>
        <Close fontSize="small" />
      </IconButton>
    </Paper>
  );
}
